<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t2">Optimism Made Simple: Proof That Positive Thinking Works!</span></p>
<p class="p0">By Hilary Walker</p>
<p class="p2"><a id="a3"></a><span href="#/005#a11" title="Link target outside of Sample">Chapter 1: Introduction</span></p>
<p class="p2"><span href="#/006#a15" title="Link target outside of Sample">Chapter 2: The Shuttle That Shouldn’t Have</span></p>
<p class="p2"><span href="#/007#a16" title="Link target outside of Sample">Chapter 3: The Greedy Farmer</span></p>
<p class="p2"><span href="#/008#a18" title="Link target outside of Sample">Chapter 4: Another Farm Tries It On</span></p>
<p class="p2"><span href="#/009#a20" title="Link target outside of Sample">Chapter 5: Beating Bell’s Palsy</span></p>
<p class="p2"><span href="#/010#a22" title="Link target outside of Sample">Chapter 6: The Unexpected Benefits of Prayer</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?7423961c